import { query } from "firebase/firestore";
import {
  getDatabase,
  ref,
  set,
  onValue,
  orderByChild,
} from "firebase/database";
import { DB } from "../constants/DB";

// export async function getDataByDB(database) {
//   console.log("getDataByDB", database);
//   const q = query(collection(db, database), orderBy("fileNo"));
//   const querySnapshot = await getDocs(q);

//   let data = [];
//   querySnapshot.forEach((doc) => {
//     data.push({ key: doc.id, ...doc.data() });
//   });
//   return data;
// }

export async function writeData(id, data, dbName) {
  const db = getDatabase();
  set(ref(db, `${dbName}/` + id), data);
}

export function getDataByDB(dbName, reverse = false) {
  const db = getDatabase();
  const dbRef = ref(db, `${dbName}/`);
  return new Promise((resolve, reject) => {
    onValue(dbRef, (snapshot) => {
      const data = snapshot.val();

      let tableData = Object.keys(data || {}).map((key) => {
        return { ...data[key], key };
      });
      if (reverse) {
        tableData = tableData.reverse();
      }
      resolve(tableData);
    });
  });
}

export function getDataByDBInDict(dbName) {
  const db = getDatabase();
  const dbRef = ref(db, `${dbName}/`);
  return new Promise((resolve, reject) => {
    onValue(dbRef, (snapshot) => {
      const data = snapshot.val();
      resolve(data);
    });
  });
}

export function getClientsData(dbName, sortKey) {
  const db = getDatabase();
  const empRef = query(ref(db, `${dbName}/`), orderByChild("fileNo"));
  return new Promise((resolve, reject) => {
    onValue(empRef, (snapshot) => {
      const data = snapshot.val();
      const tableData = Object.keys(data || {}).map((key) => {
        return { ...data[key], key };
      });
      resolve(tableData);
    });
  });
}

export function getWorkFLows() {
  const db = getDatabase();
  const dbRef = ref(db, `${DB.workflows}/`);
  return new Promise((resolve, reject) => {
    onValue(dbRef, (snapshot) => {
      const data = snapshot.val();
      let workTypeFlowMap = {};
      // eslint-disable-next-line array-callback-return
      Object.keys(data || {}).map((key) => {
        const workFlow = data[key];
        workFlow.key = key;
        const workTypeId = workFlow.workTypeId;
        if (workTypeFlowMap[workTypeId]) {
          workTypeFlowMap[workTypeId].push(workFlow);
        } else {
          workTypeFlowMap[workTypeId] = [workFlow];
        }
      });

      resolve(workTypeFlowMap);
    });
  });
}
